import React from 'react';
import { Select } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

interface Option {
  label: string;
  value: string | number;
}

interface SelectFieldProps {
  name: string;
  label: string;
  options: Option[];
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export default function SelectField({ name, label, options, required, placeholder, disabled }: SelectFieldProps) {
  const { control, formState: { errors } } = useFormContext();

  const error = name.split('.').reduce((obj: any, key) => obj?.[key], errors);
  const errorMsg = error?.message as string | undefined;

  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-neutral-600 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            placeholder={placeholder}
            disabled={disabled}
            status={errorMsg ? 'error' : undefined}
            className="w-full"
            allowClear
          />
        )}
      />
      {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
    </div>
  );
}
